// src/hooks/useMe.js
// Perfil del usuario autenticado. Todas las pantallas comparten la misma sesión (services/sesion.js):
// `loaded` solo es verdadero con un perfil válido; ante un error NUNCA se asume un rol por defecto.
import { useEffect, useSyncExternalStore } from 'react';
import { suscribir, leerSesion, cargarSesion } from '../services/sesion';
import { getToken } from '../services/api';

export function useMe() {
  const s = useSyncExternalStore(suscribir, leerSesion);
  const token = getToken();
  useEffect(() => { cargarSesion(); }, [token]);
  // Un token distinto al de la sesión cargada (recién iniciada u otro usuario) cuenta como "cargando" desde el
  // primer render: nunca se usa el perfil (o el "sin sesión") de antes.
  const vigente = !token || s.token === token;
  const estado = vigente ? s.estado : 'loading';
  const me = vigente ? s.me : { uid: null, role: null, sucursalId: null, username: '' };
  return { ...me, role: me.role || 'viewer', loaded: estado === 'authenticated', estado, mensaje: (vigente && s.mensaje) || '',
    reintentar: () => cargarSesion({ forzar: true }) };
}
